import { render, staticRenderFns } from "./payments-table.vue?vue&type=template&id=11d4a3f4&"
import script from "./payments-table.vue?vue&type=script&lang=js&"
export * from "./payments-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports